import { closeItemPeek } from 'owa-calendar-peek';
import { orchestrator } from 'satcheljs';
import { AgendaScenarioId } from '../constants';
import { updateSelectedCalendarEvent } from 'owa-agenda-events-list';

orchestrator(closeItemPeek, () => {
    updateSelectedCalendarEvent(null, AgendaScenarioId);
});
